import { CLEAR_CHANGE_PASSWORD } from './index';

export const clearChangePasswordAction = (changePassword) => ({
    type: CLEAR_CHANGE_PASSWORD,
    changePassword
});